import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDecryptAction } from '../../../../ts/ServerApi/types/actionNames';
import { encryptContent, EncryptionActionType } from '../../../actions/spaces/EncryptContentAction';
import { SessionServerSelectors, SessionSiteSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const DecryptAction: IEntityAction<IContentInfo, IDecryptAction> = {
  name: 'decrypt',
  translateName: Messages.decrypt_action,
  isVisible: (targetItems: IContentInfo[], appState: AppState) => {
    return SessionServerSelectors.extractEncryptionEnabledOmniSwitch(appState) && SessionSiteSelectors.isSiteEARModeEnabled(appState) && !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IDecryptAction, targetItems: IContentInfo[]) => {
    return targetItems.length > 1 || !!(availableActions && availableActions.decryptExtracts);
  },
  createReduxAction: (targetItems: IContentInfo[]) => encryptContent(targetItems, EncryptionActionType.decryptExtracts)
};
